<select [id]="id" multiple="multiple">

</select>